module.exports = __webpack_public_path__ + "assets/upreach-logo-weiss.png";


//////////////////
// WEBPACK FOOTER
// ./images/upreach-logo-weiss.png
// module id = 709
// module chunks = 0